var TopButton =
/** @class */
function () {
  function TopButton(name) {
    this.codeWX = $(name);
    this.winDom = $(window);
    this.htmlBody = $('html, body');
    this.init();
  }

  TopButton.prototype.init = function () {
    console.log(5);
    this.backToTop();
  };

  TopButton.prototype.backToTop = function () {
    var _a = this,
        codeWX = _a.codeWX,
        winDom = _a.winDom,
        htmlBody = _a.htmlBody;

    codeWX.hide();
    winDom.scroll(function () {
      // 当window的scrolltop距离大于1时，go to
      if ($(this).scrollTop() > 260) {
        codeWX.fadeIn();
      } else {
        codeWX.fadeOut();
      }
    });
    codeWX.click(function () {
      htmlBody.animate({
        scrollTop: 0
      }, 300);
      return false;
    });
  };

  return TopButton;
}();

export default TopButton;